import { AxiosRequestConfig } from 'axios'

const removeArticleFromFavorite = (
  type: string,
  id: string
): AxiosRequestConfig => ({
  url: `/${type}/favorite/remove`,
  method: 'POST',
  params: {
    id
  }
})

export { removeArticleFromFavorite }
